import { baseColors } from "@Constants/baseStyles"
import { StyleSheet } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingHorizontal: RFValue(20),
        paddingVertical: RFValue(18),
        borderRadius: RFValue(10),
        backgroundColor: baseColors.green.light,
        marginBottom: RFValue(18)
    },
    child: {
        marginTop: RFValue(20),
        flexDirection: "row"
    }
})

export default styles
